var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',_vm._l((_vm.videos),function(aVideo,i){return _c('video-row',{key:`vid-${i}`,attrs:{"video":aVideo}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }